import { ReactNode } from 'react';
import {
  Box,
  Grid,
  makeStyles,
  createStyles,
  CircularProgress,
} from '@material-ui/core';
import { DefaultButton, SubTitle1Text, colors } from 'design-system';

const useStyles = makeStyles(() =>
  createStyles({
    boxContainer: {
      height: '100%',
      backgroundColor: colors.white,
      boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.05)',
      borderRadius: 10,
      padding: 10,
      maxHeight: 620,
    },
    logo: { marginRight: 11 },
  }),
);

type Props = {
  isMobile?: boolean;
  children: ReactNode;
  onCancel: () => void;
  onMainClick: () => void;
  buttonText: string;
  loading?: boolean;
  disabled?: boolean;
};

const PinCardLayout = ({
  isMobile,
  children,
  buttonText,
  loading,
  disabled,
  onMainClick,
  onCancel,
}: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <>
      <Grid item xs={12} md={5}>
        <Box
          display="flex"
          flexDirection="column"
          className={classes.boxContainer}
        >
          <Box
            display="flex"
            flexDirection="column"
            sx={{ flexGrow: 1, padding: '20px' }}
          >
            <Box display="flex" mb={2}>
              <img
                src="svg/signature.svg"
                alt="signature_icon"
                className={classes.logo}
                data-testid="icon-image"
              />
              <SubTitle1Text>PIN de seguridad</SubTitle1Text>
            </Box>
            {children}
          </Box>
          {!isMobile && (
            <>
              <Box sx={{ px: 4 }} data-testid="desktop-buttons">
                <DefaultButton
                  variant="default"
                  fullWidth
                  type="button"
                  onClick={onMainClick}
                  disabled={disabled || loading}
                  data-testid="main-btn"
                >
                  {buttonText}{' '}
                  {loading && (
                    <>
                      &nbsp;&nbsp;
                      <CircularProgress
                        size={20}
                        data-testid="spinner-btn"
                        style={{ color: colors.light_silver }}
                      />
                    </>
                  )}
                </DefaultButton>
              </Box>
              <Box sx={{ my: '10px', px: 4 }}>
                <DefaultButton
                  variant="outlined"
                  fullWidth
                  type="button"
                  onClick={onCancel}
                  data-testid="cancel-btn"
                >
                  Cancelar
                </DefaultButton>
              </Box>
            </>
          )}
        </Box>
      </Grid>
      {isMobile && (
        <Grid item xs={12} data-testid="mobile-buttons">
          <Box display="flex" flexDirection="column">
            <Box sx={{ px: 0 }}>
              <DefaultButton
                variant="default"
                fullWidth
                type="button"
                onClick={onMainClick}
                disabled={disabled || loading}
                data-testid="main-btn"
              >
                {buttonText}{' '}
                {loading && (
                  <>
                    &nbsp;&nbsp;
                    <CircularProgress
                      size={20}
                      data-testid="spinner-btn"
                      style={{ color: colors.light_silver }}
                    />
                  </>
                )}
              </DefaultButton>
            </Box>
            <Box sx={{ my: '10px', px: 0 }}>
              <DefaultButton
                variant="outlined"
                fullWidth
                type="button"
                onClick={onCancel}
                data-testid="cancel-btn"
              >
                Cancelar
              </DefaultButton>
            </Box>
          </Box>
        </Grid>
      )}
    </>
  );
};

export default PinCardLayout;
